var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", [
        _c("p", [
          _vm._v(
            "ALS is always looking for innovative approaches to working with our customers. Please get in touch using the following methods:"
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "list-unstyled" }, [
          _c(
            "li",
            [
              _c("font-awesome-icon", {
                staticClass: "mr-2",
                attrs: { icon: "phone", "fixed-width": "" }
              }),
              _vm._v("+64 7 974 4740\n      ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("font-awesome-icon", {
                staticClass: "mr-2",
                attrs: { icon: "envelope", "fixed-width": "" }
              }),
              _vm._v(" "),
              _c(
                "a",
                { attrs: { href: "mailto:ALSFood.Hamilton@alsglobal.com" } },
                [_vm._v("ALSFood.Hamilton@alsglobal.com")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "mb-3" },
            [
              _c("font-awesome-icon", {
                staticClass: "mr-2",
                attrs: { icon: "external-link-alt", "fixed-width": "" }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.analytica.co.nz",
                    target: "_blank"
                  }
                },
                [_vm._v("www.analytica.co.nz")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c("strong", [_vm._v("Ruakura Research Centre")]),
            _vm._v(" "),
            _c("br"),
            _vm._v("10 Bisley Road,\n        "),
            _c("br"),
            _vm._v("Private Bag 3123,\n        "),
            _c("br"),
            _vm._v("Hamilton 3214\n        "),
            _c("br"),
            _vm._v("New Zealand\n      ")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf6573c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf6573c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = P3QC
// module chunks = 1